import { createAuthClient } from 'better-auth/react';

const baseURL = process.env.NEXT_PUBLIC_BETTER_AUTH_URL ?? '';

// Explicit annotation fixes TS2742: better-auth's inferred client type references a deep
// `.pnpm/@better-auth/core/oauth2` path that can't be named in emitted declarations under the
// composite / project-references build, which crashed the Next type-check worker (silent
// ELIFECYCLE in dev, hard build failure in prod) whenever `/login` imported this module.
// Pinning to the nameable `ReturnType<typeof createAuthClient>` lets tsc emit a portable type.
export const authClient: ReturnType<typeof createAuthClient> = createAuthClient({
  baseURL,
  basePath: '/api/tenancy/v1/auth',
});

// Better Auth 1.x: `signIn` is an object (`signIn.email(...)`); `forgetPassword` was renamed
// to `requestPasswordReset`. The `(auth)/login`, `forgot-password`, and `reset-password` pages
// use these directly off `authClient` to keep the call sites self-documenting.
export const { useSession, signIn, signOut, requestPasswordReset, resetPassword } = authClient;
